import type { IconType } from '../../types/SharedIconProps';

import { icons } from '../../iconography/iconography';

export function getValidIconKey(icon: string): IconType | null {
  if (Object.prototype.hasOwnProperty.call(icons, icon)) {
    return icon as IconType;
  }
  console.warn(
    `[EDS Icon] Invalid icon prop "${icon}" — not a registered icon name.`,
  );
  return null;
}
